import MergeRequestModal from './MergeRequestModal';

export default MergeRequestModal;



// WEBPACK FOOTER //
// ./src/client/Components/MergeRequestModal/index.js